import { Box, Container, Paper, Typography } from '@mui/material';
import './Chdpp.css';
import Footer from './Footer';
import LawAppBar from './LawAppBar';

export default function Chdpp() {

    return (
        <div className="App">
            <LawAppBar />
            <Container
                maxWidth="lg"
                sx={{
                    padding: { xs: '20px', sm: '40px' },
                    marginTop: '40px',
                    marginBottom: '60px',
                    textAlign: 'left'
                }}
            >
                {/* Header Section */}
                <Box sx={{ textAlign: 'center', marginBottom: '60px' }}>
                    <Typography
                        variant="h3"
                        component="h1"
                        gutterBottom
                        sx={{
                            color: 'var(--text-primary)',
                            fontWeight: 400,
                            fontSize: { xs: '2rem', sm: '2.8rem', md: '3.2rem' },
                            marginBottom: '1rem',
                            letterSpacing: '-0.02em',
                            lineHeight: 1.2
                        }}
                    >
                        Consumer Health Data Privacy Policy
                    </Typography>
                    <Typography
                        variant="h6"
                        sx={{
                            color: 'var(--text-secondary)',
                            fontSize: { xs: '1rem', sm: '1.2rem' },
                            fontWeight: 400,
                            fontStyle: 'italic'
                        }}
                    >
                        Last Updated: Feb 4, 2026
                    </Typography>
                </Box>

                {/* Introduction */}
                <Paper
                    elevation={0}
                    sx={{
                        padding: { xs: '32px', sm: '48px' },
                        borderRadius: '8px',
                        boxShadow: 'var(--shadow-light)',
                        border: '1px solid var(--border-color)',
                        marginBottom: '48px'
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'var(--text-primary)',
                            fontSize: { xs: '1rem', sm: '1.1rem' },
                            lineHeight: 1.8
                        }}
                    >
                        This Consumer Health Data Privacy Policy supplements the AttorneyAide General Privacy Policy and applies to "Consumer Health Data" as defined by the Washington My Health My Data Act (MHMDA) and similar state laws.
                    </Typography>
                </Paper>

                {/* Section 1: Categories of Consumer Health Data Collected */}
                <Paper
                    elevation={0}
                    sx={{
                        padding: { xs: '32px', sm: '48px' },
                        borderRadius: '8px',
                        boxShadow: 'var(--shadow-light)',
                        border: '1px solid var(--border-color)',
                        marginBottom: '48px'
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h2"
                        gutterBottom
                        sx={{
                            color: 'var(--text-primary)',
                            fontWeight: 500,
                            fontSize: { xs: '1.8rem', sm: '2.2rem' },
                            marginBottom: '24px',
                            letterSpacing: '-0.01em'
                        }}
                    >
                        1. Categories of Consumer Health Data Collected
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'var(--text-primary)',
                            fontSize: { xs: '1rem', sm: '1.1rem' },
                            lineHeight: 1.8,
                            marginBottom: '16px'
                        }}
                    >
                        We collect only the data necessary to provide our medical record review and chronology services. This includes:
                    </Typography>
                    <Box component="ul" sx={{ margin: 0, paddingLeft: '24px', color: 'var(--text-primary)', marginBottom: '16px' }}>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Individual Health Conditions & Diagnoses:</strong> Information found within medical records uploaded by Law Professionals.
                        </Typography>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Medical Interventions & Procedures:</strong> Records of surgeries, treatments, and clinical outcomes.
                        </Typography>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Prescription Information:</strong> Data regarding medication use and history.
                        </Typography>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Vital Signs & Measurements:</strong> Physical health data extracted from clinical notes.
                        </Typography>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Inferred Health Data:</strong> Chronologies and summaries generated by our AI that "infer" health status or severity from raw medical data.
                        </Typography>
                    </Box>
                </Paper>

                {/* Section 2: Sources of Consumer Health Data */}
                <Paper
                    elevation={0}
                    sx={{
                        padding: { xs: '32px', sm: '48px' },
                        borderRadius: '8px',
                        boxShadow: 'var(--shadow-light)',
                        border: '1px solid var(--border-color)',
                        marginBottom: '48px'
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h2"
                        gutterBottom
                        sx={{
                            color: 'var(--text-primary)',
                            fontWeight: 500,
                            fontSize: { xs: '1.8rem', sm: '2.2rem' },
                            marginBottom: '24px',
                            letterSpacing: '-0.01em'
                        }}
                    >
                        2. Sources of Consumer Health Data
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'var(--text-primary)',
                            fontSize: { xs: '1rem', sm: '1.1rem' },
                            lineHeight: 1.8,
                            marginBottom: '16px'
                        }}
                    >
                        We collect this data from the following sources:
                    </Typography>
                    <Box component="ul" sx={{ margin: 0, paddingLeft: '24px', color: 'var(--text-primary)', marginBottom: '16px' }}>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Directly from Law Professionals:</strong> When you upload medical records, files, or clinical notes to our platform.
                        </Typography>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Automatically via the Platform:</strong> If you use our AI tools to generate summaries, we "collect" the resulting inferences.
                        </Typography>
                    </Box>
                </Paper>

                {/* Section 3: Purpose of Collection and Use */}
                <Paper
                    elevation={0}
                    sx={{
                        padding: { xs: '32px', sm: '48px' },
                        borderRadius: '8px',
                        boxShadow: 'var(--shadow-light)',
                        border: '1px solid var(--border-color)',
                        marginBottom: '48px'
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h2"
                        gutterBottom
                        sx={{
                            color: 'var(--text-primary)',
                            fontWeight: 500,
                            fontSize: { xs: '1.8rem', sm: '2.2rem' },
                            marginBottom: '24px',
                            letterSpacing: '-0.01em'
                        }}
                    >
                        3. Purpose of Collection and Use
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'var(--text-primary)',
                            fontSize: { xs: '1rem', sm: '1.1rem' },
                            lineHeight: 1.8,
                            marginBottom: '16px'
                        }}
                    >
                        We collect and use this data only as necessary to provide the service you have requested, specifically:
                    </Typography>
                    <Box component="ul" sx={{ margin: 0, paddingLeft: '24px', color: 'var(--text-primary)', marginBottom: '16px' }}>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            To extract and organize medical data into chronologies.
                        </Typography>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            To provide AI-assisted summaries for legal review.
                        </Typography>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            To ensure the security and integrity of our platform.
                        </Typography>
                    </Box>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'var(--text-primary)',
                            fontSize: { xs: '1rem', sm: '1.1rem' },
                            lineHeight: 1.8,
                            fontStyle: 'italic'
                        }}
                    >
                        Note: We do NOT use this data for advertising, marketing, or training foundation AI models.
                    </Typography>
                </Paper>

                {/* Section 4: Sharing of Consumer Health Data */}
                <Paper
                    elevation={0}
                    sx={{
                        padding: { xs: '32px', sm: '48px' },
                        borderRadius: '8px',
                        boxShadow: 'var(--shadow-light)',
                        border: '1px solid var(--border-color)',
                        marginBottom: '48px'
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h2"
                        gutterBottom
                        sx={{
                            color: 'var(--text-primary)',
                            fontWeight: 500,
                            fontSize: { xs: '1.8rem', sm: '2.2rem' },
                            marginBottom: '24px',
                            letterSpacing: '-0.01em'
                        }}
                    >
                        4. Sharing of Consumer Health Data
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'var(--text-primary)',
                            fontSize: { xs: '1rem', sm: '1.1rem' },
                            lineHeight: 1.8,
                            marginBottom: '16px'
                        }}
                    >
                        We do not "sell" your health data. We only "share" (disclose) data to the following:
                    </Typography>
                    <Box component="ul" sx={{ margin: 0, paddingLeft: '24px', color: 'var(--text-primary)', marginBottom: '16px' }}>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Processors:</strong> Third-party service providers (e.g., Cloud Hosting, LLM API providers) who are contractually bound to process data only for the purpose of providing AttorneyAide services.
                        </Typography>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Specific Affiliates:</strong>
                        </Typography>
                        <Box component="ul" sx={{ margin: 0, paddingLeft: '24px', marginTop: '4px', marginBottom: '8px' }}>
                            <Typography
                                component="li"
                                variant="body1"
                                sx={{
                                    fontSize: { xs: '1rem', sm: '1.1rem' },
                                    lineHeight: 1.8,
                                    marginBottom: '4px'
                                }}
                            >
                                Parent company: Veridical Technologies LLC
                            </Typography>
                        </Box>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Legal Obligations:</strong> To comply with valid court orders or law enforcement requests.
                        </Typography>
                    </Box>
                </Paper>

                {/* Section 5: Your Rights and How to Exercise Them */}
                <Paper
                    elevation={0}
                    sx={{
                        padding: { xs: '32px', sm: '48px' },
                        borderRadius: '8px',
                        boxShadow: 'var(--shadow-light)',
                        border: '1px solid var(--border-color)',
                        marginBottom: '48px'
                    }}
                >
                    <Typography
                        variant="h4"
                        component="h2"
                        gutterBottom
                        sx={{
                            color: 'var(--text-primary)',
                            fontWeight: 500,
                            fontSize: { xs: '1.8rem', sm: '2.2rem' },
                            marginBottom: '24px',
                            letterSpacing: '-0.01em'
                        }}
                    >
                        5. Your Rights and How to Exercise Them
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'var(--text-primary)',
                            fontSize: { xs: '1rem', sm: '1.1rem' },
                            lineHeight: 1.8,
                            marginBottom: '16px'
                        }}
                    >
                        Under MHMDA, consumers (and the individuals whose data is uploaded) have the following rights:
                    </Typography>
                    <Box component="ul" sx={{ margin: 0, paddingLeft: '24px', color: 'var(--text-primary)', marginBottom: '16px' }}>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Right to Access:</strong> You may request confirmation of whether we are processing your health data and a list of third parties with whom it has been shared.
                        </Typography>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Right to Withdraw Consent:</strong> You may withdraw your consent for future processing at any time.
                        </Typography>
                        <Typography
                            component="li"
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                lineHeight: 1.8,
                                marginBottom: '8px'
                            }}
                        >
                            <strong>Right to Deletion:</strong> You may request that we delete your consumer health data. We will cascade this request to our subprocessors.
                        </Typography>
                    </Box>
                    <Typography
                        variant="body1"
                        sx={{
                            color: 'var(--text-primary)',
                            fontSize: { xs: '1rem', sm: '1.1rem' },
                            lineHeight: 1.8
                        }}
                    >
                        To exercise these rights, please contact our DPO at: <a href="mailto:support@attorneyaide.com" style={{ color: 'var(--text-primary)', textDecoration: 'none' }}>support@attorneyaide.com</a>.
                    </Typography>
                </Paper>
            </Container>
            <Footer />
        </div>
    );
}

